// Divitsa y Arlo ven el reporte de inventario y mermas con el formato de su sistema
// (Sdo.Inicial, Compras, Ventas, Sdo.Final, Sdo.Real, Merma y % sobre ventas).
// Mientras se valida, solo lo ven los usuarios de cada lista. Para abrirlo a todo el
// grupo, quita la condición de usuario en hasDivitsaMermaAccess o hasArloMermaAccess.
export const DIVITSA_GROUP_ID = '6aa0858591e6465b0a40305e';

export const DIVITSA_MERMA_USER_IDS: string[] = [
  // cristina.ramirez@grupodvt.com.mx
  '6aa08df681f460d9eceea35b',
  // martha_ortiz@grupodvt.com.mx
  '6aa08e8081f460d9eceea37f',
  // angelica_arellanes@grupodvt.com.mx
  '6aa08ed581f460d9eceea97f'
];

export const hasDivitsaMermaAccess = (groupId: string | null | undefined, userId: string | null | undefined): boolean =>
  groupId === DIVITSA_GROUP_ID && !!userId && DIVITSA_MERMA_USER_IDS.includes(userId);

export const ARLO_GROUP_ID = '6a3ede114142dff8c20e0a56';

export const ARLO_MERMA_USER_IDS: string[] = [
  // israel@grupoarlo.com
  '6a5f98e2ec8fd0677718c0b7',
  // diana@grupoarlo.com
  '6a60196fec8fd067773091fb',
  // aljojuca@grupoarlo.com
  '6a6019efec8fd0677730984e',
  // guau@grupoarlo.com
  '6a601ab4ec8fd0677730ace2'
];

export const hasArloMermaAccess = (groupId: string | null | undefined, userId: string | null | undefined): boolean =>
  groupId === ARLO_GROUP_ID && !!userId && ARLO_MERMA_USER_IDS.includes(userId);

// Grupos que ven la tabla de mermas con el formato del sistema de inventario físico.
export const isMermaSimpleGroup = (groupId: string | null | undefined): boolean =>
  groupId === DIVITSA_GROUP_ID || groupId === ARLO_GROUP_ID;
